var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.refererUrl && !_vm.isOverlayEnabled)?_c('NavBannerContainer',{attrs:{"name":"dealer-link-back"}},[_c('primary-link',{staticClass:"back-link",nativeOn:{"click":function($event){return _vm.showSaveWorkModal.apply(null, arguments)}}},[_c('span',[_vm._v(" back to dealer website ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }